var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1280.000000, -203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#757575",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7 L13,7 L13,9 L11,9 L11,7 Z M11,10 L13,10 L13,17 L11,17 L11,10 Z",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert-info.16fffb9f08ddbbd95c1d8b282b8d0447.svg";
export { ForwardRef as ReactComponent };